import api from "../../redux/apis/api";

function getEnvelope(response) {
  return response?.data || response || {};
}

function getPayload(response) {
  const envelope = getEnvelope(response);
  return envelope?.data ?? envelope;
}

export async function fetchDevices() {
  const response = await api.get("/devices");
  const payload = getPayload(response);
  return Array.isArray(payload) ? payload : [];
}

export async function fetchCameraNodes() {
  const response = await api.get("/v2/camera/nodes");
  const payload = getPayload(response);
  return Array.isArray(payload?.nodes) ? payload.nodes : [];
}

export async function registerCameraNode(payload) {
  const response = await api.post("/v2/camera/nodes/register", payload);
  return getPayload(response);
}

export async function startCameraStream(nodeId) {
  const response = await api.post(`/v2/camera/nodes/${nodeId}/stream/start`);
  return getPayload(response);
}

export async function startCameraIntercom(nodeId) {
  const response = await api.post(`/v2/camera/nodes/${nodeId}/intercom/start`);
  return getPayload(response);
}

export async function sendCameraIntercomChunk(nodeId, payload) {
  const response = await api.post(`/v2/camera/nodes/${nodeId}/intercom/chunk`, payload);
  return getPayload(response);
}

export async function stopCameraIntercom(nodeId) {
  const response = await api.post(`/v2/camera/nodes/${nodeId}/intercom/stop`);
  return getPayload(response);
}

export async function stopCameraSession(sessionId) {
  const response = await api.post(`/v2/camera/sessions/${sessionId}/stop`);
  return getPayload(response);
}

export async function sendCameraHeartbeat(sessionId) {
  const response = await api.post(`/v2/camera/sessions/${sessionId}/heartbeat`);
  return getPayload(response);
}

export async function fetchMyCameraSessions() {
  const response = await api.get("/v2/camera/sessions/my");
  const payload = getPayload(response);
  return Array.isArray(payload?.sessions) ? payload.sessions : [];
}

export async function stopAllMyCameraSessions() {
  const response = await api.post("/v2/camera/sessions/stop-all");
  return getPayload(response);
}

export async function captureNodeSnapshot(nodeId, payload = {}) {
  const response = await api.post(`/v2/camera/nodes/${nodeId}/capture`, payload);
  return getPayload(response);
}

export async function fetchNodeLatestSnapshot(nodeId) {
  const response = await api.get(`/v2/camera/nodes/${nodeId}/snapshot/latest`);
  return getPayload(response);
}

export async function fetchNodeGrants(nodeId) {
  const response = await api.get(`/v2/camera/nodes/${nodeId}/grants`);
  const payload = getPayload(response);
  return Array.isArray(payload?.grants) ? payload.grants : [];
}
